import { Component, Input, OnInit} from '@angular/core';
import { FormsModule } from '@angular/forms';
import Quill from 'quill';
import {Select} from "primeng/select";


@Component({
  selector: 'app-writer-templates',
  standalone: true,
    imports: [
        FormsModule,
        Select,

    ],
  templateUrl: './writer-templates.component.html',
  styleUrl: './writer-templates.component.scss'
})



export class WriterTemplatesComponent implements OnInit {

      @Input() for!: string;
      private quillGetter;
      private quill;
      private target: HTMLInputElement;
      protected templateSelectionVar;
      protected lastInfoTemplate: templateInterface[] = [
        {templateId: 1, templateTitle: "Simple Thank You",
          templateContent: "Thank you for taking the time to read my project. I’m looking forward to working with you!"
        },
        {templateId: 2, templateTitle: "Stumped on a Few Things",
          templateContent: `Hello Beta Reader,
Thanks for taking the time to read my project. As you know, this is still a work in progress. I have done my best to smooth out the issues in this project, but there are a few areas that have stumped me.

 • Known issue 1

 • Known issue 2

 • Known issue 3

As soon as I figure out how to fix them, I’ll implement fixes. In the meantime, know that I’m aware that they’re problematic. If you come up with any insights while you’re reading, I’d appreciate your thoughts!

Thanks again!`
        },
        {templateId: 3, templateTitle: "Developmental Pass Things to Ignore",
          templateContent: `Dear Beta Reader,

Thanks so much for agreeing to read my project! Before you get started, I’d like to let you know a few things. Because this is a work in progress, there are still a few issues I already know about. You don’t need to comment on any of these things (which will hopefully let you sit back and enjoy the story rather than getting bogged down in details).

 • Awkward phrasing (I haven’t done a line edit yet, so if it sounds funny but you understand what’s being said, you can safely leave it be.)

 • Typos (Same deal: I’ve done a basic spellcheck, but there’s no point typo hunting in the story is going to get completely rewritten.)

 • Punctuation (…Ditto… That said, if you see a consistent error, I’d appreciate one quick comment so I can make sure I fix it in my later editing rounds)

Thanks again for jumping into this story with me. I’m looking forward to hearing what you think about the story!`
        },
        {templateId: 4, templateTitle: "Feedback Preferences",
          templateContent: `Thanks for agreeing to read my project! I’m really looking forward to working with you.

As you can imagine, I’ve got a few things I’d like you to keep an eye out for as you read. Feel free to leave a comment (please) if you see any of these.

 • Inconsistencies

 • Vanishing characters (One minute you’ve got three characters in a conversation but then one just…doesn’t show up and isn’t there when the conversation’s over? Yeah… I think I’ve found all of those, but let me know if you notice it happen.)

 • Anything confusing

Thanks so much! I hope you enjoy the story.`
        },
        {templateId: 5, templateTitle: "I'm New, Be Kind",
          templateContent: `Dear Beta Reader,

Thank you so much for agreeing to read my project. I just wanted to let you know that this is my first time sharing my work. I definitely want help, but I’d appreciate it if you would be gentle with your feedback. It takes a lot of courage to share something this close to the heart.

Thank you for your critiques and your compassion. Enjoy the story!`
        },
        {templateId: 6, templateTitle: "Criticism Wanted",
          templateContent: `Dear Beta Reader,

Thank you for agreeing to read my project. I just wanted to let you know that I’ve been around the critique block a few times. I’m confident in my writing and while I’d appreciate it if you’d point out the very strongest points of my story, I’m mostly here looking for the weak spots. I’m not easily offended and I’d rather direct, to-the-point notes instead of beating around the bush.

Thanks again. I’m looking forward to working with you.`
        },
        {templateId: 7, templateTitle: "18+ Warning",
          templateContent: `I acknowledge that I am over 18 and am about to read a book with explicit scenes.`
        },
        {templateId: 8, templateTitle: "General Content Warning",
          templateContent: `Dear Reader,

Please be aware that this book contains the following themes.

 • Theme 1

 • Theme 2

 • Theme 3

Please take care of yourself as you read. If at any time, you decide you’d rather not finish the story, just leave a comment at the spot where you’ve ended and let me know that you’re done. No explanations needed.`
        },
      ];

      constructor(){}


      ngOnInit() {
        this.target = document.getElementById(this.for) as HTMLInputElement;

        //this.quillGetter = document.getElementById(this.for);
        //this.quill = Quill.find(this.quillGetter);
      }

      textAreaFiller() {
        this.target.setRangeText(this.templateSelectionVar.templateContent, this.target.selectionStart, this.target.selectionEnd, "end");
        this.target.dispatchEvent(new Event('input'));

      }




}

export interface templateInterface {

  templateId: number;
  templateTitle: string;
  templateContent: string;

}
